import { StyledButton, StyledFlex } from '@tryhackme/thm-ui-components';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { GradientBackground } from 'src/common/components/gradient-background';
import ManagementDashboardPNG from 'src/images/pngs/subscriptions/management-dashboard.png';
import { StyledCheckIcon, StyledTextContainer, StyledDotsSmall, StyledManagementDashboard, StyledSVGContainer, StyledManagementDashboardContainer, StyledContainer, StyledFade, StyledTitle, StyledIntro, StyledDescription, StyledWhatsIncludedContainter } from './management-dashboard.styles';
export const ManagementDashboard: React.FC = () => <GradientBackground data-sentry-element="GradientBackground" data-sentry-component="ManagementDashboard" data-sentry-source-file="management-dashboard.tsx">
    <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="management-dashboard.tsx">
      <StyledTextContainer data-sentry-element="StyledTextContainer" data-sentry-source-file="management-dashboard.tsx">
        <div>
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="management-dashboard.tsx">Business or Education?</StyledTitle>
          <StyledIntro data-sentry-element="StyledIntro" data-sentry-source-file="management-dashboard.tsx">Improve Cyber Capabilities in your Business or Education Programs</StyledIntro>
          <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="management-dashboard.tsx">
            Engage in real-world guided cybersecurity training suitable for all skill levels, while tracking progress,
            identifying skills gaps, and managing development—all in one seamless platform.
          </StyledDescription>
          <StyledFlex justifyContent="flex-start" gap="1.6rem" data-sentry-element="StyledFlex" data-sentry-source-file="management-dashboard.tsx">
            <StyledButton as={Link} to="https://tryhackme.com/business" color="primary" variant="solid" data-sentry-element="StyledButton" data-sentry-source-file="management-dashboard.tsx">
              For Business
            </StyledButton>
            <StyledButton as={Link} to="/classrooms" color="add" variant="solid" data-sentry-element="StyledButton" data-sentry-source-file="management-dashboard.tsx">
              For Education
            </StyledButton>
          </StyledFlex>
        </div>
        <StyledWhatsIncludedContainter data-sentry-element="StyledWhatsIncludedContainter" data-sentry-source-file="management-dashboard.tsx">
          <p>What’s included</p>
          <ul>
            <li>
              <StyledCheckIcon icon={faCheck} data-sentry-element="StyledCheckIcon" data-sentry-source-file="management-dashboard.tsx" />
              Flexible seating
            </li>
            <li>
              <StyledCheckIcon icon={faCheck} data-sentry-element="StyledCheckIcon" data-sentry-source-file="management-dashboard.tsx" />
              Assignments to user groups
            </li>
            <li>
              <StyledCheckIcon icon={faCheck} data-sentry-element="StyledCheckIcon" data-sentry-source-file="management-dashboard.tsx" />
              Create custom learning paths
            </li>
            <li>
              <StyledCheckIcon icon={faCheck} data-sentry-element="StyledCheckIcon" data-sentry-source-file="management-dashboard.tsx" />
              Advanced user reporting
            </li>
            <li>
              <StyledCheckIcon icon={faCheck} data-sentry-element="StyledCheckIcon" data-sentry-source-file="management-dashboard.tsx" />
              CTF Builder
            </li>
          </ul>
        </StyledWhatsIncludedContainter>
      </StyledTextContainer>
      <StyledSVGContainer data-sentry-element="StyledSVGContainer" data-sentry-source-file="management-dashboard.tsx">
        <StyledDotsSmall data-sentry-element="StyledDotsSmall" data-sentry-source-file="management-dashboard.tsx" />
        <StyledManagementDashboardContainer data-sentry-element="StyledManagementDashboardContainer" data-sentry-source-file="management-dashboard.tsx">
          <StyledManagementDashboard src={ManagementDashboardPNG} data-sentry-element="StyledManagementDashboard" data-sentry-source-file="management-dashboard.tsx" />
        </StyledManagementDashboardContainer>
      </StyledSVGContainer>
    </StyledContainer>
    <StyledFade data-sentry-element="StyledFade" data-sentry-source-file="management-dashboard.tsx" />
  </GradientBackground>;